var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4B7670"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 19.9989C33.3337 12.6389 27.3603 6.66553 20.0003 6.66553C12.6403 6.66553 6.66699 12.6389 6.66699 19.9989C6.66699 26.4522 11.2537 31.8255 17.3337 33.0655V23.9989H14.667V19.9989H17.3337V16.6655C17.3337 14.0922 19.427 11.9989 22.0003 11.9989H25.3337V15.9989H22.667C21.9337 15.9989 21.3337 16.5989 21.3337 17.3322V19.9989H25.3337V23.9989H21.3337V33.2655C28.067 32.5989 33.3337 26.9189 33.3337 19.9989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c19b8e7c6373044dd1c6fa154c13849e.svg";
export { ForwardRef as ReactComponent };